/**
 * @enum
 */
const ActionTypes ={
    INCREMENT : "increment",
    DECREMENT : "decrement",
}

export default ActionTypes;